/* raw layout hash: _anonymous-web-layout:46bddf895ad9b16904cb016727a0d530aa98f8edd2dc7045c723a83746f71082 */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _anonymous-web-layout.html — chrome-less shell for public/anonymous pages. Menu entries are role-based (see AppShell / menuData.js).

export default function AnonymousWebLayout() {
  return <AppShell chrome={false} />;
}
